const APIs = {
   LOGIN: `api/Auth/LoginSuperPanel`,
   
   // Auto-Login APIs
   GENERATE_AUTO_LOGIN_TOKEN: `/api/Auth/GenerateAutoLoginToken`,
   AUTO_LOGIN: `/api/Auth/AutoLogin`,

   // Dashboard
   GET_DASHBOARD_STATS: `/api/Dashboard/GetDashboardStats`,
   GET_REVENUE_OVERVIEW: `/api/Dashboard/GetRevenueOverview`,

   //Company
   GET_COMPANY: `/api/Company/UpdatedCompanyData`,
   Get_COMPANY_BY_ID: `/api/Company/GetCompanyByID`,
   GET_ALL_COMPANIES: `/api/Company/GetCompaniesList`,
   GET_COMPANY_LOCATIONS: `/api/Company/GetCompanyLocations`,
   GET_COMPANY_PROFILE:   `/api/Company/Profile`,
   POST_ADD_COMPANY: `/api/Company/AddCompany`,
   POST_UPDATE_COMPANY: `/api/Company/UpdateSuperCompany`,
   POST_UPDATE_COMPANY_DATA : `/api/Company/UpdateCompany`,
   POST_UPDATE_WEEKLY_SERVICE_HOURS: `/api/Company/UpdateCompanyServiceHours`,
   GET_COMPANY_SETTINGS : `/api/Setting/GetCompanySettings`,
   POST_UPDATE_COMPANY_SETTING:`/api/Setting/UpdateCompanySettings`,
   DELETE_COMPANY: `/api/Company/DeleteCompany`,
   GET_SA_COMPANY_RESTAURANT_CATEGORIES: `/api/Company/SuperAdmin/RestaurantCategories`,
   PUT_SA_COMPANY_RESTAURANT_CATEGORIES: `/api/Company/SuperAdmin/RestaurantCategories`,



   // Devices

   GET_ALL_DEVICES_OF_COMPANY : `/api/Till/BO_GetCompanyDevices`,
   PATCH_UPDATE_DEVICE_STATUS : `/api/Device/UpdateCompanyStatus`,
   DELETE_COMPANY_TILL: `/api/Till/DeleteCompanyTill`,
   GET_COMPANY_DEVICES: `/api/Device/GetCompanyDevices`,
   ADD_COMPANY_DEVICE: `/api/Device/AddCompanyDevice`,
   UPDATE_COMPANY_DEVICE: `/api/Device/UpdateCompanyDevice`,
   DELETE_COMPANY_DEVICE: `/api/Device/DeleteCompanyDevice`,

  // Payment Gateways

  GET_ALL_PAYMENT_GATEWAYS:`/api/PaymentGateway/BO_GetPaymentGateways`,
  POST_ADD_PAYMENT_GATEWAY: `/api/PaymentGateway/AddPaymentGateway`,
  UPDATE_PAYMENT_GATEWAY: `/api/PaymentGateway/UpdatePaymentGateway`,
  DELETE_PAYMENT_GATEWAY: `/api/PaymentGateway/DeletePaymentGateway`,

  // Payment Gateway Platforms (Super Admin)
  SA_GET_ALL_PAYMENT_GATEWAY_PLATFORMS: `/api/PaymentGatewayPlatform/SA_GetAllPaymentGatewayPlatforms`,
  SA_GET_PAYMENT_GATEWAY_PLATFORM_BY_ID: `/api/PaymentGatewayPlatform/SA_GetPaymentGatewayPlatformByID`,
  SA_ADD_UPDATE_PAYMENT_GATEWAY_PLATFORM: `/api/PaymentGatewayPlatform/SA_AddUpdatePaymentGatewayPlatform`,
  SA_DELETE_PAYMENT_GATEWAY_PLATFORM: `/api/PaymentGatewayPlatform/SA_DeletePaymentGatewayPlatform`,
  SA_UPDATE_PAYMENT_GATEWAY_PLATFORM_STATUS: `/api/PaymentGatewayPlatform/SA_UpdatePaymentGatewayPlatformStatus`,

  // Payment Providers

  GET_ALL_PAYMENT_PROVIDERS: `/api/PaymentProvider/GetAllPaymentProviders`,
  GET_PAYMENT_PROVIDER_BY_ID: `/api/PaymentProvider/GetPaymentProviderByID`,
  POST_ADD_UPDATE_PAYMENT_PROVIDER: `/api/PaymentProvider/AddUpdatePaymentProvider`,
  DELETE_PAYMENT_PROVIDER: `/api/PaymentProvider/DeletePaymentProvider`,
  PATCH_UPDATE_PAYMENT_PROVIDER_STATUS: `/api/PaymentProvider/UpdatePaymentProviderStatus`,
  POST_UPDATE_PAYMENT_PROVIDER_SORT_ORDER: `/api/PaymentProvider/UpdatePaymentProviderSortOrder`,

  // Allergens APIs (SuperAdmin - No CompID restrictions)
  GET_ALL_ALLERGENS: `/api/Allergen/SuperAdmin/GetAllAllergens`,
  GET_ALLERGEN_BY_ID: `/api/Allergen/SuperAdmin/GetAllergenByID`,
  POST_INSERT_ALLERGEN: `/api/Allergen/SuperAdmin/InsertAllergen`,
  PUT_UPDATE_ALLERGEN: `/api/Allergen/SuperAdmin/UpdateAllergen`,
  DELETE_ALLERGEN: `/api/Allergen/SuperAdmin/DeleteAllergen`,
  POST_UPDATE_ALLERGEN_SORT_ORDER: `/api/Allergen/SuperAdmin/UpdateAllergenSortOrder`,

  // Resturant Categories APIs (SuperAdmin)
  GET_ALL_RESTURANT_CATEGORIES: `/api/ResturantCategory/SuperAdmin/GetAllResturantCategories`,
  GET_RESTURANT_CATEGORY_BY_ID: `/api/ResturantCategory/SuperAdmin/GetResturantCategoryByID`,
  POST_INSERT_RESTURANT_CATEGORY: `/api/ResturantCategory/SuperAdmin/InsertResturantCategory`,
  PUT_UPDATE_RESTURANT_CATEGORY: `/api/ResturantCategory/SuperAdmin/UpdateResturantCategory`,
  DELETE_RESTURANT_CATEGORY: `/api/ResturantCategory/SuperAdmin/DeleteResturantCategory`,
  POST_UPDATE_RESTURANT_CATEGORY_SORT_ORDER: `/api/ResturantCategory/SuperAdmin/UpdateResturantCategorySortOrder`,
  POST_UPLOAD_RESTURANT_CATEGORY_IMAGE: `/api/ResturantCategory/SuperAdmin/UploadResturantCategoryImage`,

  // Marketplace Campaigns (SuperAdmin)
  GET_ALL_MARKETPLACE_CAMPAIGNS: `/api/MarketplaceCampaign/SuperAdmin/GetAllCampaigns`,
  GET_MARKETPLACE_CAMPAIGN_BY_ID: `/api/MarketplaceCampaign/SuperAdmin/GetCampaignById`,
  POST_INSERT_MARKETPLACE_CAMPAIGN: `/api/MarketplaceCampaign/SuperAdmin/InsertCampaign`,
  PUT_UPDATE_MARKETPLACE_CAMPAIGN: `/api/MarketplaceCampaign/SuperAdmin/UpdateCampaign`,
  DELETE_MARKETPLACE_CAMPAIGN: `/api/MarketplaceCampaign/SuperAdmin/DeleteCampaign`,
  POST_UPDATE_MARKETPLACE_CAMPAIGN_DISPLAY_ORDER: `/api/MarketplaceCampaign/SuperAdmin/UpdateCampaignDisplayOrder`,
  POST_ASSIGN_CAMPAIGN_RESTAURANTS: `/api/MarketplaceCampaign/SuperAdmin/AssignRestaurants`,
  GET_PENDING_CAMPAIGN_OPT_INS: `/api/MarketplaceCampaign/SuperAdmin/GetPendingOptIns`,
  POST_APPROVE_CAMPAIGN_OPT_IN: `/api/MarketplaceCampaign/SuperAdmin/ApproveOptIn`,
  POST_REJECT_CAMPAIGN_OPT_IN: `/api/MarketplaceCampaign/SuperAdmin/RejectOptIn`,
  POST_UPLOAD_MARKETPLACE_CAMPAIGN_BANNER: `/api/MarketplaceCampaign/SuperAdmin/UploadCampaignBanner`,

  // Marketplace Riders (SuperAdmin)
  GET_ALL_MARKETPLACE_RIDERS: `/api/MarketplaceRider/SuperAdmin/GetAllRiders`,
  GET_MARKETPLACE_RIDER_BY_ID: `/api/MarketplaceRider/SuperAdmin/GetRiderById`,
  POST_UPSERT_MARKETPLACE_RIDER: `/api/MarketplaceRider/SuperAdmin/UpsertRider`,
  POST_SET_MARKETPLACE_RIDER_APPROVAL: `/api/MarketplaceRider/SuperAdmin/SetApprovalStatus`,
  POST_UPLOAD_MARKETPLACE_RIDER_DOCUMENT: `/api/MarketplaceRider/SuperAdmin/UploadRiderDocument`,
  GET_ACTIVE_DISPATCHES: `/api/MarketplaceRider/SuperAdmin/GetActiveDispatches`,
  GET_DISPATCH_TIMELINE: `/api/MarketplaceRider/SuperAdmin/GetDispatchTimeline`,
  POST_CANCEL_ORDER_FROM_DISPATCH: `/api/MarketplaceRider/SuperAdmin/CancelOrderFromDispatch`,
  POST_SKIP_CURRENT_OFFER: `/api/MarketplaceRider/SuperAdmin/SkipCurrentOffer`,
  POST_FORCE_DISPATCH_RETRY: `/api/MarketplaceRider/SuperAdmin/ForceDispatchRetry`,
  HUB_SUPERADMIN_DISPATCH_MONITOR: `/hub/SuperAdminDispatchMonitor`,

  // Marketplace order audit / performance (SuperAdmin)
  GET_ORDER_TIMELINE: `/api/MarketplaceOrderAudit/SuperAdmin/GetOrderTimeline`,
  GET_MARKETPLACE_PERFORMANCE: `/api/MarketplaceOrderAudit/SuperAdmin/GetMarketplacePerformance`,
  GET_MARKETPLACE_RIDER_PERFORMANCE: `/api/MarketplaceOrderAudit/SuperAdmin/GetRiderPerformance`,

  // Marketplace service zones (SuperAdmin)
  GET_MARKETPLACE_ZONES: `/api/MarketplaceRider/SuperAdmin/GetZones`,
  POST_UPSERT_MARKETPLACE_ZONE: `/api/MarketplaceRider/SuperAdmin/UpsertZone`,
  POST_SET_MARKETPLACE_ZONE_ACTIVE: `/api/MarketplaceRider/SuperAdmin/SetZoneActive`,

  // Marketplace delivery fee slabs (global km bands)
  GET_MARKETPLACE_DELIVERY_FEE_SLABS: `/api/MarketplaceRider/SuperAdmin/GetDeliveryFeeSlabs`,
  POST_UPSERT_MARKETPLACE_DELIVERY_FEE_SLAB: `/api/MarketplaceRider/SuperAdmin/UpsertDeliveryFeeSlab`,
  POST_SET_MARKETPLACE_DELIVERY_FEE_SLAB_ACTIVE: `/api/MarketplaceRider/SuperAdmin/SetDeliveryFeeSlabActive`,

  // Rider shift slots (SuperAdmin)
  GET_RIDER_SHIFT_SLOTS: `/api/MarketplaceRider/SuperAdmin/GetShiftSlots`,
  POST_UPSERT_RIDER_SHIFT_SLOT: `/api/MarketplaceRider/SuperAdmin/UpsertShiftSlot`,
  POST_DELETE_RIDER_SHIFT_SLOT: `/api/MarketplaceRider/SuperAdmin/DeleteShiftSlot`,
  GET_RIDER_SHIFT_SLOT_BOOKINGS: `/api/MarketplaceRider/SuperAdmin/GetShiftSlotBookings`,
  POST_BOOK_RIDER_SHIFT_SLOT: `/api/MarketplaceRider/SuperAdmin/BookShiftSlot`,
  POST_CANCEL_RIDER_SHIFT_BOOKING: `/api/MarketplaceRider/SuperAdmin/CancelShiftBooking`,

  // Rider wallet / remittance / payouts (SuperAdmin)
  POST_GENERATE_RIDER_REMITTANCE_INVOICES: `/api/MarketplaceRider/SuperAdmin/GenerateDailyRemittanceInvoices`,
  POST_CREATE_RIDER_ADHOC_REMITTANCE: `/api/MarketplaceRider/SuperAdmin/CreateAdHocRemittanceInvoice`,
  GET_RIDER_REMITTANCE_INVOICES: `/api/MarketplaceRider/SuperAdmin/GetRemittanceInvoices`,
  GET_RIDER_REMITTANCE_INVOICE_BY_ID: `/api/MarketplaceRider/SuperAdmin/GetRemittanceInvoiceById`,
  POST_REVIEW_RIDER_REMITTANCE_INVOICE: `/api/MarketplaceRider/SuperAdmin/ReviewRemittanceInvoice`,
  GET_RIDER_CREDIT_LIMITS: `/api/MarketplaceRider/SuperAdmin/GetCreditLimits`,
  POST_UPSERT_RIDER_CREDIT_LIMIT: `/api/MarketplaceRider/SuperAdmin/UpsertCreditLimit`,
  GET_RIDER_WALLET: `/api/MarketplaceRider/SuperAdmin/GetRiderWallet`,
  GET_RIDER_LEDGER: `/api/MarketplaceRider/SuperAdmin/GetRiderLedger`,
  POST_CREATE_RIDER_PAYOUT: `/api/MarketplaceRider/SuperAdmin/CreateRiderPayout`,
  POST_APPROVE_RIDER_PAYOUT: `/api/MarketplaceRider/SuperAdmin/ApproveRiderPayout`,
  POST_MARK_RIDER_PAYOUT_PAID: `/api/MarketplaceRider/SuperAdmin/MarkRiderPayoutPaid`,
  GET_RIDER_PAYOUTS: `/api/MarketplaceRider/SuperAdmin/GetRiderPayouts`,

  // Rider performance rules / violation history (SuperAdmin)
  GET_RIDER_PERFORMANCE_RULES: `/api/MarketplaceRiderPerformance/SuperAdmin/GetRules`,
  POST_UPSERT_RIDER_PERFORMANCE_RULE: `/api/MarketplaceRiderPerformance/SuperAdmin/UpsertRule`,
  POST_SET_RIDER_PERFORMANCE_RULE_ACTIVE: `/api/MarketplaceRiderPerformance/SuperAdmin/SetRuleActive`,
  GET_RIDER_STAR_SETTINGS: `/api/MarketplaceRiderPerformance/SuperAdmin/GetStarSettings`,
  POST_UPSERT_RIDER_STAR_SETTINGS: `/api/MarketplaceRiderPerformance/SuperAdmin/UpsertStarSettings`,
  GET_RIDER_VIOLATIONS: `/api/MarketplaceRiderPerformance/SuperAdmin/GetViolations`,
  GET_RIDER_STAR_HISTORY: `/api/MarketplaceRiderPerformance/SuperAdmin/GetStarHistory`,
  POST_ADJUST_RIDER_STAR: `/api/MarketplaceRiderPerformance/SuperAdmin/AdjustStar`,

  // Restaurant marketplace settlements (SuperAdmin)
  POST_GENERATE_RESTAURANT_SETTLEMENTS: `/api/MarketplaceRestaurantSettlement/SuperAdmin/GenerateWeeklySettlements`,
  POST_PREVIEW_RESTAURANT_SETTLEMENTS: `/api/MarketplaceRestaurantSettlement/SuperAdmin/PreviewWeeklySettlements`,
  GET_RESTAURANT_SETTLEMENTS: `/api/MarketplaceRestaurantSettlement/SuperAdmin/GetSettlements`,
  GET_RESTAURANT_SETTLEMENT_BY_ID: `/api/MarketplaceRestaurantSettlement/SuperAdmin/GetSettlementById`,
  POST_APPROVE_RESTAURANT_SETTLEMENT: `/api/MarketplaceRestaurantSettlement/SuperAdmin/ApproveSettlement`,
  POST_MARK_RESTAURANT_SETTLEMENT_PAID: `/api/MarketplaceRestaurantSettlement/SuperAdmin/MarkSettlementPaid`,
  POST_CANCEL_RESTAURANT_SETTLEMENT: `/api/MarketplaceRestaurantSettlement/SuperAdmin/CancelSettlement`,
  POST_RESTAURANT_SETTLEMENT_ADJUSTMENT: `/api/MarketplaceRestaurantSettlement/SuperAdmin/PostAdjustment`,
  GET_RESTAURANT_PAYOUT_PROFILE: `/api/MarketplaceRestaurantSettlement/SuperAdmin/GetPayoutProfile`,
  POST_UPSERT_RESTAURANT_PAYOUT_PROFILE: `/api/MarketplaceRestaurantSettlement/SuperAdmin/UpsertPayoutProfile`,

  // Units APIs (SuperAdmin - No CompID restrictions)
  GET_ALL_UNITS: `/api/Unit/SuperAdmin/GetAllUnits`,
  GET_UNIT_BY_ID: `/api/Unit/SuperAdmin/GetUnitByID`,
  POST_INSERT_UNIT: `/api/Unit/SuperAdmin/InsertUnit`,
  PUT_UPDATE_UNIT: `/api/Unit/SuperAdmin/UpdateUnit`,
  DELETE_UNIT: `/api/Unit/SuperAdmin/DeleteUnit`,

   // Staff
   GET_COMPANY_STAFF: `/api/Staff/BO_GetCompanyStaff`,
   DELETE_COMPANY_STAFF: `/api/Staff/DeleteStaff`,
   GET_STAFF_DATA: `/api/Staff/GetUserByUserName`,
   ADD_STAFF: `/api/Staff/AddUser`,
   UPDATE_STAFF: `/api/Staff/UpdateUser`,
   UPDATE_STAFF_WEEKLY_SCHEDULE: `/api/Staff/UpdateUserWeeklySchedule`,
   UPDATE_PASSWORD: `/api/Staff/UpdatePassword`,
   ADD_COMPANY_STAFF: `/api/Staff/AddCompanyStaff`,
   UPDATE_COMPANY_STAFF: `/api/Staff/UpdateCompanyStaff`,


   //Roles
   GET_ROLES: `/api/RolePermission/GetAllRoles`,
   GET_ROLE_BY_ID: `/api/RolePermission/GetRoleByID`,
   ADD_ROLE: `/api/RolePermission/AddNewRole`,
   UPDATE_ROLE: `/api/RolePermission/UpdateRolePermission`,
   DELETE_ROLE: `/api/RolePermission/DeleteRole`,


   // Countries
   GET_COUNTRIES: `/api/Country/GetAllCountries`,

   //City

   GET_ALL_CITIES: `/api/City/GetAllCitiesListForCountryCode`,

   // Categories
   GET_CATEGORIES: `/api/RootCategories/BO_GetAllCategories`,
   GET_CATEGORY_ROOT_ID: `/api/RootCategories/GetRootCategoryByRootCatID`,
   ADD_CATEGORY: `/api/RootCategories/AddCategory`,
   UPDATE_CATEGORY: `/api/RootCategories/UpdateCategory`,
   POST_UPDATE_CATEGORY_SORT_ORDER: `/api/RootCategories/UpdateCategorySortOrder`,
   POST_UPDATE_CATEGORY_STATUS: `/api/RootCategories/UpdateCategoryStatus`,
   DELETE_ROOT_CATEGORY: `/api/RootCategories/DeleteCategory`,

   // Menus

   POST_ADD_MENU: `/api/Menu/AddMenu`,
   POST_ADD_MENU_GROUP_LIST: `/api/MenuGroup/AddMenuGroupList`,
   GET_MENU_LIST: `/api/Menu/BO_GetAllMenus`,
   GET_MENU_BY_MENU_ID: `/api/Menu/GetMenuByMenuID`,
   GET_All_MENU_GroupS: `/api/Menu/GetAllMenusWithTheirGroups`,
   DELETE_MENU: `/api/Menu/DeleteMenu`,
   PUT_UPDATE_MENU_AND_MENU_GROUP: `/api/Menu/UpdateMenu`,
   POST_UPDATE_MENU_SORT_ORDER: `/api/Menu/UpdateMenuSortOrder`,
   POST_UPDATE_MENU_STATUS: `/api/Menu/UpdateMenuStatus`,


   //  Item
   POST_CREATE_MENU_ITEM: `/api/Item/AddMenuItem`,
   GET_ALL_ITEMS_FOR_GRID: `/api/Item/BO_GetAllItems`,
   GET_ALL_PRODUCTS: `/api/Item/GetAllMenuItems`,
   GET_ALL_ONLY_PRODUCTS: `/api/Item/GetAllOnlyMenuItems`,
   POST_UPLOAD_PRODUCT_IMAGE: `/api/Item/UploadMenuItemImage`,
   GET_ITEM_BY_ID: `/api/Item/GetMenuItemByID`,
   PUT_UPDATE_ITEM: `/api/Item/UpdateMenuItem`,
   DELETE_ITEM: `/api/Item/DeleteMenuItem`,
   POST_UPDATE_ITEM_SORT_ORDER: `/api/Item/UpdateMenuItemSortOrder`,
   POST_UPDATE_ITEM_STATUS: `/api/Item/UpdateMenuItemStatus`,
   GET_ALL_SHORTED_PRODUCTS: `/api/Item/GetMenuItemsWithShortDetail`,


   // Modifiers
   GET_SEARCH_MODIFIERS: `/api/Modifier/BO_SearchModifier`,


   // Modifier Group

   POST_ADD_MODIFIER_GROUP: `/api/ModifierGroup/AddModifierGroup`,
   GET_ALL_MODIFIER_GROUPS: `/api/ModifierGroup/BO_GetAllModifierGroups`,
   DELETE_MODIFIER_GROUP: `/api/ModifierGroup/DeleteModifierGroup`,
   POST_CHANGE_SKIP_ABLE: `/api/ModifierGroup/ChangeModifierSKipAble`,
   GET_MODIFIER_GROUP_BY_ID: `/api/ModifierGroup/GetModifierGroupByID`,
   PUT_UPDATE_MODIFIER_GROUP: `/api/ModifierGroup/UpdateModifierGroup`,



   //Discount
   GET_ALL_DISCOUNTS: `/api/Discount/BO_GetCompanyDiscountEntry`,
   GET_DISCOUNT_BY_ID: `/api/Discount/GetDiscountByID`,
   POST_ADD_DISCOUNT: `/api/Discount/InsertDiscountEntry`,
   PUT_UPDATE_DISCOUNT: `/api/Discount/UpdateDiscountEntry`,
   DELETE_DISCOUNT: `/api/Discount/DeleteDiscountEntry`,



   //Orders
   GET_ALL_ORDERS : `/api/RecvOrder/BO_GetOrders`,
   DELETE_ORDER: `/api/RecvOrder/ArchieveRecvOrder`,


   //Service Time
   GET_ALL_SERVICE_TIME: `/api/ServiceTime/GetAllServiceTimes`,
   GET_SERVICE_TIME_BY_ID: `/api/ServiceTime/GetServiceTimeforID`,
   POST_ADD_SERVICE_TIME: `/api/ServiceTime/AddServiceTime`,
   PUT_UPDATE_SERVICE_TIME: `/api/ServiceTime/UpdateServiceTime`,
   DELETE_SERVICE_TIME: `/api/ServiceTime/DeleteServiceTime`,

   //Service Time Details
   GET_SERVICE_TIME_DETAILS: `/api/ServiceTimeDetail/GetServiceTimeDetailList`,
   GET_SERVICE_TIME_DETAIL_BY_ID: `/api/ServiceTimeDetail/GetAllServiceTimeDetailsByCompany`,
   POST_ADD_SERVICE_TIME_DETAIL: `/api/ServiceTimeDetail/AddServiceTimeDetail`,



   // Customers
   GET_ALL_CUSTOMERS: `/api/Customer/BO_GetCustomerList`,
  GET_MARKETPLACE_CUSTOMERS: `/api/SuperAdminCustomer/GetMarketplaceCustomers`,
  GET_MARKETPLACE_CUSTOMER_BY_ID: `/api/SuperAdminCustomer/GetMarketplaceCustomerById`,
   GET_ALL_CUSTOMERS_GROUP_TYPE_LIST: `/api/CustomerTypeGroup/GetAllCustomerTypeGroups`,
   GET_CUSTOMERS_GROUP: `/api/CustomerTypeGroup/BO_GetCustomerTypeGroupList`,
   POST_ADD_UPDATE_CUSTOMER_GROUP: `/api/CustomerTypeGroup/AddUpdateCustomerGroup`,
   DELETE_CUSTOMER_GROUP_TYPE: `/api/CustomerTypeGroup/DeleteCustomerGroup`,
   POST_ADD_CUSTOMER: `/api/Customer/AddCustomer`,
   GET_CUSTOMER_BY_ID: `/api/Customer/GetCustomerByID`,
   PUT_UPDATE_CUSTOMER: `/api/Customer/UpdateCustomer`,
   PATCH_UPDATE_CUSTOMER_EMAIL_ADDRESS: `/api/Customer/UpdateCustomerEmailAddress`,
   DELETE_CUSTOMER_BY_ID: `/api/Customer/DeleteCustomerByID`,


   // Receipt Info
   GET_RECEIPT_INFO :`/api/Receipt/GetReceiptInfo`,
   POST_UPDATE_RECEIPT_INFO :`/api/Receipt/UpdateReceiptInfo`,

   // Currency
   GET_ALL_CURRENCIES: `/api/Shared/GetAllCurrencies`,
   GET_ALL_TIMEZONE : `/api/Shared/GetAllTimeZones`,


   // ==================== SUBSCRIPTION SYSTEM ====================
   
   // Packages
   GET_ALL_PACKAGES: `/api/Package/GetAllPackages`,
   GET_PACKAGE_BY_ID: `/api/Package/GetPackageByID`,
   GET_PACKAGE_WITH_PRICES: `/api/Package/GetPackageWithPrices`,
   GET_ALL_PACKAGES_WITH_PRICES: `/api/Package/GetAllPackagesWithPrices`,
   POST_ADD_PACKAGE: `/api/Package/AddPackage`,
   PUT_UPDATE_PACKAGE: `/api/Package/UpdatePackage`,
   DELETE_PACKAGE: `/api/Package/DeletePackage`,
   PATCH_UPDATE_PACKAGE_STATUS: `/api/Package/UpdatePackageStatus`,

   // Package Prices
   GET_PACKAGE_PRICES: `/api/Package/GetPackagePrices`,
   POST_ADD_PACKAGE_PRICE: `/api/Package/AddPackagePrice`,
   PUT_UPDATE_PACKAGE_PRICE: `/api/Package/UpdatePackagePrice`,
   DELETE_PACKAGE_PRICE: `/api/Package/DeletePackagePrice`,

   // Subscriptions
   GET_ACTIVE_SUBSCRIPTION: `/api/Subscription/GetActiveSubscription`,
   GET_COMPANY_ACTIVE_SUBSCRIPTION: `/api/Subscription/GetCompanyActiveSubscription`,
   GET_SUBSCRIPTION_BY_ID: `/api/Subscription/GetSubscriptionByID`,
   GET_COMPANY_SUBSCRIPTIONS: `/api/Subscription/GetCompanySubscriptions`,
   GET_EXPIRING_SUBSCRIPTIONS: `/api/Subscription/GetExpiringSubscriptions`,
   POST_CREATE_SUBSCRIPTION: `/api/Subscription/CreateSubscription`,
   PUT_UPDATE_SUBSCRIPTION: `/api/Subscription/UpdateSubscription`,
   POST_CANCEL_SUBSCRIPTION: `/api/Subscription/CancelSubscription`,
   POST_RENEW_SUBSCRIPTION: `/api/Subscription/RenewSubscription`,
   POST_UPDATE_EXPIRED_SUBSCRIPTIONS: `/api/Subscription/UpdateExpiredSubscriptions`,
   POST_RUN_RENEWAL_INVOICE_JOB: `/api/Subscription/RunRenewalInvoiceJob`,

   // Invoices
   GET_INVOICE_BY_ID: `/api/Invoice/GetInvoiceByID`,
   GET_INVOICE_BY_NUMBER: `/api/Invoice/GetInvoiceByNumber`,
   GET_COMPANY_INVOICES: `/api/Invoice/GetCompanyInvoices`,
   GET_INVOICES_BY_COMPANY_ID: `/api/Invoice/GetInvoicesByCompanyID`,
   GET_ALL_INVOICES: `/api/Invoice/GetAllInvoices`,
   GET_INVOICE_WITH_DETAILS: `/api/Invoice/GetInvoiceWithDetails`,
   POST_CREATE_INVOICE: `/api/Invoice/CreateInvoice`,
   PUT_UPDATE_INVOICE: `/api/Invoice/UpdateInvoice`,
   DELETE_INVOICE: `/api/Invoice/DeleteInvoice`,
   POST_MARK_INVOICE_AS_PAID: `/api/Invoice/MarkInvoiceAsPaid`,
   GET_INVOICE_ITEMS: `/api/Invoice/GetInvoiceItems`,
   POST_CREATE_MANUAL_INVOICE: `/api/Invoice/CreateManualInvoice`,

   // Payments
   GET_TRANSACTION_BY_ID: `/api/Payment/GetTransactionByID`,
   GET_TRANSACTION_BY_REFERENCE: `/api/Payment/GetTransactionByReference`,
   GET_TRANSACTIONS_BY_INVOICE: `/api/Payment/GetTransactionsByInvoiceID`,
   GET_PAYMENT_HISTORY: `/api/Payment/GetPaymentHistory`,
   GET_COMPANY_PAYMENT_HISTORY: `/api/Payment/GetCompanyPaymentHistory`,
   GET_ALL_TRANSACTIONS: `/api/Payment/GetAllTransactions`,
   POST_PROCESS_PAYMENT: `/api/Payment/ProcessPayment`,
   PATCH_UPDATE_TRANSACTION_STATUS: `/api/Payment/UpdateTransactionStatus`,
   POST_REFUND_TRANSACTION: `/api/Payment/RefundTransaction`,
   POST_RECORD_MANUAL_PAYMENT: `/api/Payment/RecordManualPayment`,
   POST_RECORD_MANUAL_PAYMENT_WITH_PROOF: `/api/Payment/RecordManualPaymentWithProof`,
   POST_UPLOAD_PAYMENT_PROOF: `/api/Payment/UploadPaymentProof`,
   POST_APPROVE_PAYMENT_PROOF: `/api/Payment/ApprovePaymentProof`,
   POST_APPROVE_PENDING_PAYMENT: `/api/Payment/ApprovePendingPayment`,
   POST_REJECT_PAYMENT_PROOF: `/api/Payment/RejectPaymentProof`,
   GET_PENDING_PAYMENT_PROOFS: `/api/Payment/GetPendingProofs`,

   // Billing bank accounts & payment settings
   GET_ALL_BILLING_BANK_ACCOUNTS: `/api/BillingBankAccount/GetAllBankAccounts`,
   GET_ACTIVE_BILLING_BANK_ACCOUNTS: `/api/BillingBankAccount/GetActiveBankAccounts`,
   POST_ADD_BILLING_BANK_ACCOUNT: `/api/BillingBankAccount/AddBankAccount`,
   PUT_UPDATE_BILLING_BANK_ACCOUNT: `/api/BillingBankAccount/UpdateBankAccount`,
   PATCH_DEACTIVATE_BILLING_BANK_ACCOUNT: `/api/BillingBankAccount/DeactivateBankAccount`,
   GET_BILLING_PAYMENT_SETTINGS: `/api/BillingSettings/GetPaymentSettings`,
   PUT_UPDATE_BILLING_PAYMENT_SETTINGS: `/api/BillingSettings/UpdatePaymentSettings`,

  // Platform support info
  GET_SA_SUPPORT_INFO: `/api/SupportInfo/SA_GetSupportInfo`,
  PUT_SA_UPDATE_SUPPORT_INFO: `/api/SupportInfo/SA_UpdateSupportInfo`,

  // Marketplace order timeout settings (SuperAdmin, global)
  GET_SA_MARKETPLACE_ORDER_TIMEOUT_SETTINGS: `/api/MarketplaceOrderTimeoutSettings/Get`,
  PUT_SA_MARKETPLACE_ORDER_TIMEOUT_SETTINGS: `/api/MarketplaceOrderTimeoutSettings/Update`,
  POST_SA_UPLOAD_MARKETPLACE_EMAIL_APP_ICON: `/api/MarketplaceOrderTimeoutSettings/UploadEmailAppIcon`,

   // Subscription Addons
   GET_ALL_ADDONS: `/api/Addon/GetAllAddons`,
   GET_ALL_ADDONS_WITH_PRICES: `/api/Addon/GetAllAddonsWithPrices`,
   GET_ADDON_BY_ID: `/api/Addon/GetAddonByID`,
   GET_ADDON_WITH_PRICES: `/api/Addon/GetAddonWithPrices`,
   POST_ADD_ADDON: `/api/Addon/AddAddon`,
   PUT_UPDATE_ADDON: `/api/Addon/UpdateAddon`,
   DELETE_ADDON: `/api/Addon/DeleteAddon`,
   PATCH_UPDATE_ADDON_STATUS: `/api/Addon/UpdateAddonStatus`,
   GET_ADDON_PRICES: `/api/Addon/GetAddonPrices`,
   POST_ADD_ADDON_PRICE: `/api/Addon/AddAddonPrice`,
   PUT_UPDATE_ADDON_PRICE: `/api/Addon/UpdateAddonPrice`,
   DELETE_ADDON_PRICE: `/api/Addon/DeleteAddonPrice`,

  // Company Subscription Addons (Linking)
  GET_COMPANY_ACTIVE_ADDONS: `/api/Subscription/GetCompanyActiveAddons`,
  POST_ADD_ADDON_TO_SUBSCRIPTION: `/api/Subscription/AddAddonToSubscription`,
  DELETE_REMOVE_ADDON_FROM_SUBSCRIPTION: `/api/Subscription/RemoveAddonFromSubscription`,
  PATCH_UPDATE_SUBSCRIPTION_ADDON_QUANTITY: `/api/Subscription/UpdateAddonQuantity`,

  // Quotes
  GET_ALL_QUOTES: `/api/Quote/GetAllQuotes`,
  GET_ACTIVE_QUOTES: `/api/Quote/GetActiveQuotes`,
  GET_QUOTE_BY_ID: `/api/Quote/GetQuoteByID`,
  POST_ADD_QUOTE: `/api/Quote/AddQuote`,
  PUT_UPDATE_QUOTE: `/api/Quote/UpdateQuote`,
  DELETE_QUOTE: `/api/Quote/DeleteQuote`,
  PATCH_UPDATE_QUOTE_STATUS: `/api/Quote/UpdateQuoteStatus`,

  // Bulk Upload (SuperAdmin - requires CompID)
  GET_BULK_UPLOAD_TEMPLATE: `/api/BulkUpload/GenerateTemplate`,
  POST_BULK_UPLOAD_PROCESS: `/api/BulkUpload/ProcessUpload`,

  // POS App Releases (SuperAdmin)
  GET_SA_POS_RELEASE_PLATFORMS: `/api/PosAppRelease/SA_GetPlatforms`,
  GET_SA_ALL_POS_RELEASES: `/api/PosAppRelease/SA_GetAllReleases`,
  GET_SA_POS_RELEASE_BY_ID: `/api/PosAppRelease/SA_GetReleaseById`,
  POST_SA_UPLOAD_POS_RELEASE: `/api/PosAppRelease/SA_UploadRelease`,
  PUT_SA_UPDATE_POS_RELEASE: `/api/PosAppRelease/SA_UpdateRelease`,
  DELETE_SA_POS_RELEASE: `/api/PosAppRelease/SA_DeleteRelease`,
  GET_SA_DOWNLOAD_POS_RELEASE: `/api/PosAppRelease/SA_DownloadRelease`,
  GET_POS_CHECK_FOR_UPDATE: `/api/PosAppRelease/CheckForUpdate`,
  GET_POS_CHECK_UPDATE: `/api/PosAppRelease/CheckUpdate`,
  GET_POS_CHECK_FOR_UPDATE_ALIAS: `/api/PosAppRelease/POS_CheckForUpdate`,
  GET_POS_DOWNLOAD_RELEASE: `/api/PosAppRelease/DownloadRelease`,
 
}

export default APIs;
